/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl, ValidatorFn } from '@angular/forms';

export function controlValueIsSameValidator(controlToMatch: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const valuesMatch = control.value === controlToMatch.value;
        return valuesMatch ? null : {controlValueIsSame: {value: control.value}};
    };
}
